export default function GridBackground() {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      {/* Base gradient — no dead black, gentle color drift */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(140deg, #141B2A 0%, #17213A 40%, #1A2848 70%, #1F2C4E 100%)',
        }}
      />

      {/* Soft warm glow — top-left */}
      <div
        className="absolute"
        style={{
          top: '-20%',
          left: '-15%',
          width: '70vw',
          height: '70vw',
          background:
            'radial-gradient(circle at center, rgba(122, 168, 238, 0.10) 0%, rgba(122, 168, 238, 0.04) 35%, rgba(122, 168, 238, 0) 65%)',
          filter: 'blur(4px)',
        }}
      />

      {/* Soft warm glow — bottom-right amber */}
      <div
        className="absolute"
        style={{
          bottom: '-25%',
          right: '-20%',
          width: '75vw',
          height: '75vw',
          background:
            'radial-gradient(circle at center, rgba(232, 168, 124, 0.09) 0%, rgba(232, 168, 124, 0.03) 40%, rgba(232, 168, 124, 0) 70%)',
          filter: 'blur(4px)',
        }}
      />

      {/* Dot grid layer */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            'radial-gradient(circle, rgba(255, 255, 255, 0.28) 1.6px, transparent 1.9px)',
          backgroundSize: '38px 38px',
          backgroundPosition: '0 0',
        }}
      />

      {/* Radial vignette to fade dots at edges and add depth */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse at center, rgba(20, 23, 31, 0) 0%, rgba(20, 23, 31, 0.30) 55%, rgba(20, 23, 31, 0.78) 100%)',
        }}
      />
    </div>
  );
}